"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupNode = void 0;
var react_1 = __importDefault(require("react"));
require("./styles/group-node.scss");
/**
 * GroupNode - Custom node component for group/level containers
 * Displays group name at the top, no connection handles
 */
exports.GroupNode = function (_a) {
    var data = _a.data;
    return (react_1.default.createElement("div", { className: "strategy-group-node" },
        react_1.default.createElement("div", { className: "group-header" }, data.label),
        react_1.default.createElement("div", { className: "group-content" })));
};
